<template>
  <div class="subsection" v-if="selectedVendor">
    <div
      class="table-data__tool clearfix"
      style="
      background: rgb(214, 213, 213);
    border: 1px solid #e2e2e2;
    padding: 5px 10px;"
    >
      <!-- <div class="float-left">
        <button
              class="sideB bLightBlue">( {{ vendor.name }} ) Contact List</button>
      </div>-->
      <div class="float-right">
        <button class="sideB bLightBlue" @click="createItem()" v-if="hasPermission('create vendor_contact')">
          <i class="zmdi zmdi-plus"></i> Add New Contact
        </button>
      </div>
    </div>
    <DataTable
      ref="datatable"
      :settings="datatable.settings"
      :dataColumns="datatable.columns"
      :dataFeed="datatable.dataFeed"
      :dataHandle="datatable.handle"
      :dataTableHeight="datatable.height"
      :defaultSortBy="datatable.sortBy"
      :defaultOrderBy="datatable.orderBy"
      :customViewItem="viewItem"
      :customEditItem="editItem"
      :allowView="allowView"
      :allowEdit="allowEdit"
      :allowDelete="allowDelete"
      :hasContextMenu="hasContextMenu"
    >
      <template slot="menuButtons" slot-scope="props">
        <template v-if="props.item && props.item.data">
          <li @click="$refs.datatable.viewItem($event, props.item.data)" v-if="allowView(props.item.data)">View</li>
          <li @click="$refs.datatable.editItem($event, props.item.data)" v-if="allowEdit(props.item.data)">Edit</li>
          <li @click="$refs.datatable.confirmDelete($event, props.item.data)" v-if="allowDelete(props.item.data)">Delete</li>
          <li @click="setToPrimary(props.item.data.id)" v-if="!props.item.data.primary_contact">Set to Primary</li>
        </template>
      </template> 
    </DataTable>
    <VendorContactEdit
      :formMode="formMode"
      :formShow="isEditing"
      :selectedVendor="selectedVendor"
      :selectedItem="selectedItem"
      @closeVendorContactEdit="closeVendorContactEdit"
      @reload="$refs.datatable.reload()"
    />
  </div>
</template>
<script>
import VendorContactEdit from "./VendorContactEdit";

export default {
  name: "VendorContact",
  components: {
    VendorContactEdit
  },
  props: {
    selectedVendor: Object
  },
  data() {
    return {
      selectedItemContact: [],
      datatable: {
        settings: {
          sectionName: "vendor",
          webService: this.$root.WebService.vendorContact
        },
        dataFeed: null,
        handle: null,
        columns: [
          { key: 'name', title: "Name", type: "input", width: "14%", value: null },
          { key: 'position', title: "Position", type: "input", width: "14%", value: null },
          { key: 'contact_email', title: "Email", type: "input", width: "20%", value: null },
          { key: 'contact_mobile', title: "Contact Mobile", type: "input", width: "13%", value: null },
          { key: 'contact_tel', title: "Tel No.", type: "input", width: "13%", value: null },
          { key: 'other_contact', title: "Other Contact", type: "input", width: "20%", value: null },
          { key: 'primary_contact', title: 'Primary Contact', type: 'select', width: '6%', value: null, datafilter: this.$options.filters.booleanText, selectOptions: 
            {
              key: 'primary_contact', valueKey: 'value', displayKey: 'title', datas: [{ value: 0, title: 'No' }, { value: 1, title: 'Yes' }]
            }
          },
        ],
        sortBy: null,
        orderBy: "desc",
        height: "60vh",
      },
      datas: [],
      filteredDatas: [],
      isEditing: false,
      selectedItem: null,
      formMode: null
    };
  },
  mounted() {
    this.datatable.handle = (res) => this.datas = res.data.data
    this.datatable.dataFeed = {
      method: 'get',
      url: this.WebService.vendor + '/' + this.selectedVendor.id + '/contact'
    }
  },
  methods: {
    viewItem(item) {
      this.formMode = 'view'
      this.isEditing = true
      this.selectedItem = item
    },
    editItem(item) {
      this.formMode = 'edit'
      this.isEditing = true
      this.selectedItem = item
    },
    createItem() {
      this.formMode = 'create'
      this.isEditing = true
    },
    closeVendorContactEdit() {
      this.formMode = null
      this.isEditing = false
      this.selectedItem = null
    },
    allowView(item) {
      return this.hasPermission('read vendor_contact')
    },
    allowEdit(item) {
      return this.hasPermission('update vendor_contact')
    },
    allowDelete(item) {
      return this.hasPermission('delete vendor_contact') && item.primary_contact != 1
    },
    hasContextMenu(item) {
      return this.allowView(item) || this.allowEdit(item) || this.allowDelete(item)
    },
    setToPrimary(id) {
      this.processing = true
      this.$http
        .post(this.$root.WebService.vendorContact + '/setPrimary', {vendorId: this.selectedVendor.id, contactId: id})
        .then((res) => {
          this.alertNotice({
            type: 'success',
            title: 'Success',
            content: 'Update successfully.',
          })

          this.$refs.datatable.reload()
          this.$refs.datatable.$refs.virtualList.forceRender()

        })
        .catch((err) => {
          this.alertNotice({
            type: 'danger',
            title: 'Failed',
            content: err.data,
          })
          this.processing = false
        })
        .finally()
    }
  }
};
</script>